






















import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { AttributeTreeData } from '@/models/reports/attribute-tree-data';
import { Field } from '@/models/reports/report-field';
import { QueryResult } from '@/models/reports/report-query-result';
import { DateTime } from 'luxon';

const isoDateTimeRegex = /\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|)/;

@Component
export default class ReportResults extends Vue {
    @Prop({ required: true }) private queryResult: any;
    @Prop({ required: true }) private pageSize: number;
    private pageNumber: number = 1;

    private get columns(): Array<string> {
        if (this.queryResult.header) {
            const keys = Object.keys(this.queryResult.header);
            const columns = new Array<string>();
            keys.forEach((key) => {
                columns.push(this.queryResult.header[key]);
            });
            return columns;
        }

        return [];
    }

    private get totalRecords(): number {
        if (this.queryResult.results) {
            return this.queryResult.results.length;
        }

        return 0;
    }

    private get totalPages(): number {
        return Math.ceil(this.totalRecords / this.pageSize);
    }

    private get pagedResults(): Array<{ [key: string]: any }> {
        if (!this.queryResult.results) {
            return [];
        }

        if (this.queryResult.results.length < 1) {
            return this.queryResult.results;
        }

        const max = this.pageNumber * this.pageSize;
        const start = (this.pageNumber - 1) * this.pageSize;
        const end = max > this.totalRecords ? this.totalRecords : max;

        const results = this.queryResult.results.slice(start, end);
        results.forEach((item: any) => {
            this.columns.forEach((column: string) => {
                const columnName = column.charAt(0).toLowerCase() + column.substr(1);
                if (item[columnName] != null && item[columnName].toString().match(isoDateTimeRegex)) {
                    item[columnName] = DateTime.fromISO(item[columnName]).toFormat('dd/MM/yyyy');
                }
            });
        });

        return results;
    }

    @Watch('queryResult.results')
    private onQueryResultResultsChange(): void {
        this.pageNumber = 1;
    }
}
